import axios from 'axios'
import qs from 'qs'
import constants from '../../../helpers/constants'
import { NOVA_POSHTA_PRICE_LIMIT } from '@/constants'
// import cookieHelper from '@/helpers/cookieHelper'
import { GoogleEnhancedEcommerce } from '@/services/AnalyticService'

const formDataKey = constants.IS_MANAGER_CHECKOUT ? 'formDataManager' : 'formData'

export default {
  state: {
    formData: {
      callback: false
    },
    isDisabledCallback: false, // флаг обязательного перезвона
    isCallbackServiceEnabled: window?.config?.isCallbackEnabledOnCheckout ?? false, // флаг включения/отключения функционала "Перезвонить мне"
    loadingComponents: [],
    errorFromServer: null,
    createOrderInfo: null,
    currentCity: null,
    currency: '',
    isManagerPage: constants.IS_MANAGER_CHECKOUT,
    isManagerLogged: false,
    managersClientData: null,
    managerStoreUid: window?.config?.['manager_store'] ?? '',
    managerStore: localStorage.getItem('managerSelectedStore') ? JSON.parse(localStorage.getItem('managerSelectedStore')) : null,
    isGuest: false,
    guestUserExist: false,
    guestRecaptcha: '',
    userAgreement: !!constants.IS_MANAGER_CHECKOUT
  },
  getters: {
    isCheckoutFormValid (state, getters, rootState) {
      const { formData } = state

      return ((formData.paymentType === '3' && getters.isLegalFormValid) ||
        (formData.paymentType && formData.paymentType !== '3')) &&
        getters.isContactFormValid && rootState.paymentForm.paymentTypes.length && state.userAgreement && getters.isDeliveryFormValid && (!state.isManagerPage || (state.isManagerPage && state.isManagerLogged)) && (getters.isVatFormValid) &&
        ((state.isGuest && state.guestRecaptcha) || !state.isGuest)
    },
    currentCityName (state, getters, rootState) {
      return state.currentCity ? state.currentCity[rootState.translation.language] : ''
    },
    totalPrice (state, getters, rootState) {
      const { deliveryType } = state.formData

      const delivery = rootState.contactsForm.deliveryTypes.find(type => type.methodId === deliveryType?.methodId)

      let deliveryCost = delivery?.fullCost ?? 0
      if ((rootState.cart.cart.originCost - parseInt(rootState.bonuses.currentBonusValue)) > NOVA_POSHTA_PRICE_LIMIT) {
        deliveryCost = 0
      }

      return rootState.cart.cart.originCost + deliveryCost - (state.loadingComponents.bonusesInModal ? 0 : rootState.bonuses.currentBonusValue)
    }
  },
  mutations: {
    SET_IS_GUEST (state, bool) {
      state.isGuest = bool
    },
    SET_USER_AGREEMENT (state, bool) {
      state.userAgreement = bool
    },
    SET_GUEST_USER_EXIST (state, bool) {
      state.guestUserExist = bool
    },
    SET_GUEST_RECAPTCHA (state, val) {
      state.guestRecaptcha = val
    },
    REDUCE_FORM_DATA (state, data) {
      const formDataFromStorage = JSON.parse(localStorage.getItem(formDataKey))
      const prevData = formDataFromStorage || state.formData
      const reducedFormData = { ...prevData, ...data }
      localStorage.setItem(formDataKey, JSON.stringify(reducedFormData))

      state.formData = reducedFormData
    },
    SET_FORM_DATA_FROM_STORAGE (state) {
      const formDataFromStorage = JSON.parse(localStorage.getItem(formDataKey))
      if (formDataFromStorage) {
        state.formData = { ...formDataFromStorage, prevCallback: formDataFromStorage.callback }
      }
    },
    SET_IS_CONTACT_FORM_VALID (state, bool) {
      state.isContactFormValid = bool
    },
    SET_PAYMENT_FORM_EMPTY (state, bool) {
      state.isPaymentFormEmpty = bool
    },
    SET_LOADING_COMPONENTS (state, data) {
      state.loadingComponents = { ...state.loadingComponents, ...data }

      if (!data) {
        delete state.loadingComponents[Object.keys(data)[0]]
      }
    },
    SET_ERROR_FROM_SERVER (state, data) {
      let error = data
      if (state.errorFromServer === data) {
        if (error[error.length] === ' ') {
          error.substr(0, error.length - 1)
        } else {
          error = error + ' '
        }
      }
      state.errorFromServer = error
    },
    SET_CREATE_ORDER_INFO (state, data) {
      state.createOrderInfo = data
    },
    SET_CURRENCY (state, data) {
      state.currency = data
    },
    SET_IS_MANAGER_LOGGED (state, isLogged) {
      state.isManagerLogged = isLogged
    },
    SET_MANAGERS_CLIENT_DATA (state, data) {
      state.managersClientData = data
    },
    SET_MANAGER_STORE_UID (state, uid) {
      state.managerStoreUid = uid
    },
    SET_MANAGER_STORE (state, data) {
      state.managerStore = data
    },
    SET_IS_DISABLED_CALLBACK_STATUS (state, bool) {
      state.isDisabledCallback = bool
    }
  },
  actions: {
    SET_USER_AGREEMENT_ACTION (ctx, data) {
      ctx.commit('SET_USER_AGREEMENT', data)
    },
    SET_IS_GUEST (ctx, data) {
      ctx.commit('SET_IS_GUEST', data)
      if (!data) {
        ctx.commit('SET_GUEST_RECAPTCHA', '')
      }
    },
    SET_GUEST_USER_EXIST (ctx, data) {
      ctx.commit('SET_GUEST_USER_EXIST', data)
    },
    SET_GUEST_RECAPTCHA (ctx, data) {
      ctx.commit('SET_GUEST_RECAPTCHA', data)
    },
    SET_FORM_DATA (ctx, data) {
      ctx.commit('REDUCE_FORM_DATA', data)
    },
    SET_FORM_DATA_FROM_LOCAL_STORAGE (ctx) {
      ctx.commit('SET_FORM_DATA_FROM_STORAGE')
    },
    VALIDATE_CHECKOUT_FORM ({ commit, state, getters, dispatch }) {
      if (!getters.isContactFormValid) commit('SET_CONTACT_FORM_EMPTY', true)
      else commit('SET_CONTACT_FORM_EMPTY', false)

      if (!getters.isDeliveryFormValid) commit('SET_DELIVERY_FORM_IS_EMPTY', true)

      if (state.formData?.paymentType === '3' && getters.isLegalFormValid) {
        commit('SET_IS_PAYMENT_FORM_EMPTY_WARNING', false)
      } else {
        commit('SET_IS_PAYMENT_FORM_EMPTY_WARNING', true)
      }

      dispatch('VALIDATE_ANOTHER_RECIPIENT_FORM')
    },
    FETCH_ORDER_INFO ({ commit, state, getters, rootGetters, rootState, dispatch }) {
      let isGoogleAnalyticsAllowed = 0
      try {
        const consentUpdateData = window?.dataLayer?.slice().reverse().find(el => el[0] === 'consent' && el[1] === 'update')
        try {
          const cmpData = window.__cmp('getCMPData')
          if (cmpData && cmpData.vendorConsents.s26) {
            isGoogleAnalyticsAllowed = 1
          }
        } catch (e) {}
        const orderInfo = {
          User: {
            name: state.formData.name,
            last_name: state.formData.lastName,
            phone: state.formData.phone
          },
          CustomerForm: {
            phone: state.formData.phone || state.formData.recipientPhone,
            email: state.formData.email || state.formData.recipientEmail
          },
          DeliveryForm: {
            city: null,
            method: state.formData.deliveryType.methodId,
            deliveryCity: {
              ...rootState.deliveryForm.deliveryCity,
              name: rootState.deliveryForm.deliveryCity?.original_name || rootState.deliveryForm.deliveryCity?.name
            },
            isFreeEnterDeliveryData: +rootState.deliveryForm.isFreeEnterDeliveryData
          },
          OrderForm: {
            note: state.formData.note,
            paymentMethod: state.formData.paymentType,
            recipient_phone: state.formData.phone || state.formData.recipientPhone
          }
        }
        // const analyticsCookie = cookieHelper.getCookie('_ga_R2CVLVEMEM')
        const itemsData = rootState.cart.products.map(el => GoogleEnhancedEcommerce.getGoogleEnhancedEcommerceData(el.analytics_data[0]))
        let items = {}
        itemsData.forEach(el => {
          const { promotion_name, promotion_id, creative_slot, item_list_name, item_list_id } = el
          items[el.item_id] = {
            promotion_name, promotion_id, creative_slot, item_list_name, item_list_id
          }
        })
        orderInfo.AnalyticsForm = {
          ...GoogleEnhancedEcommerce.getAnalyticsFormData({
            phone: state.formData.phone || state.formData.recipientPhone,
            email: state.formData.email || state.formData.recipientEmail,
            externalUserId: window.config?.user_id || '',
            items
          }),
          isGoogleAnalyticsAllowed
        }
        if (consentUpdateData) {
          const { ad_personalization, ad_storage, ad_user_data, analytics_storage } = consentUpdateData[2]
          orderInfo.AnalyticsForm = {
            ...orderInfo.AnalyticsForm,
            ad_personalization,
            ad_storage,
            ad_user_data,
            analytics_storage
          }
        }

        if (rootState.paymentForm.vatForm.needVatFacture) {
          orderInfo.vatForm = rootState.paymentForm.vatForm
        }
        if (state.formData.isLegalPerson && state.formData.taxNumber) {
          orderInfo.User.tax_number = parseInt(state.formData.taxNumber.replaceAll('-', ''))
        }
        // Если включен функционал "Перезвонить мне" или обязательный перезвон - добавляем информацию в заказ
        if (state.isCallbackServiceEnabled || state.isDisabledCallback) {
          // Отправляем флаг обратного звонка (все наоборот 0 перезвонить, 1 не перезванивать...)
          orderInfo.OrderForm.callBack = state.formData.callback ? 0 : 1
        } else {
          // тупой костыль!!!!
          orderInfo.OrderForm.callBack = 1
        }

        if (state.isManagerPage) {
          orderInfo.OrderForm.callback = 1
          orderInfo.client_phone = state.formData.phone

          if (state.formData.logistNote) {
            orderInfo.OrderForm.comment_for_logist = state.formData.logistNote
          }
        }

        if (rootState.deliveryForm.isAnotherRecipient) {
          const { recipientName, recipientLastName, recipientPhone, recipientEmail } = state.formData
          orderInfo.OrderForm = {
            ...orderInfo.OrderForm,
            another_recipient: true,
            recipientName: recipientName,
            recipientEmail: recipientEmail,
            recipientLastName: recipientLastName,
            recipient_phone: recipientPhone
          }
        }

        if (rootState.bonuses && rootState.bonuses.currentBonusValue) {
          orderInfo.bonuses = rootState.bonuses.currentBonusValue
        }

        dispatch('VALIDATE_CHECKOUT_FORM')
        if (state.formData.partsPaymentValue) {
          orderInfo.OrderForm.countPartsPayPart = state.formData.partsPaymentValue
        }

        if (state.formData.deliveryInfo) {
          const { deliveryType, deliveryInfo } = state.formData
          const { methodId } = deliveryType
          const { street, flat: flatNumber, house, deliveryTime, city, zip, flat } = deliveryInfo

          if (methodId === 1 || methodId === 3 || methodId === 5 || methodId === 10 || methodId === 11) {
            orderInfo.WarehouseForm = { warehouse: deliveryInfo.deliverySpot.uid }
          } else if (methodId === 4) {
            orderInfo.AddressForm = { street: street.name, house, flatNumber }
          } else if (methodId === 2 || methodId === 6) {
            orderInfo.AddressForm = { street: street.name, house, flatNumber, deliveryDay: deliveryTime.date, deliveryTime: deliveryTime.time }
          } else if (methodId === 7 || methodId === 9) {
            orderInfo.AddressFormInternational = { street, house, city, zipCode: zip, flat }
          }
        }

        if (state.formData.paymentType === '3' && state.formData.legalPersonInfo) {
          const { formId, formRef, full_name: organization, inn, pdv_status, egr, firmEgr, firmTitle, phoneNumberForPayment, documentNdsStatus } = state.formData.legalPersonInfo
          orderInfo.PaymentForm = {
            organization_type: formRef,
            egrpou: egr,
            organization: organization,
            inn: inn,
            pdv_status: pdv_status ? 1 : 0,
            document_nds_status: documentNdsStatus
          }

          if (formId === '82a553c6-4f94-11e8-a3de-005056b2fc3d') {
            orderInfo.PaymentForm.organization = firmTitle
            orderInfo.PaymentForm.egrpou = firmEgr
          } else if (formId === 'd558bfcc-7456-11df-ad52-000c29118aa7') {
            orderInfo.PaymentForm.egrpou = inn
          } else if (documentNdsStatus === '1' && !egr && inn) {
            orderInfo.PaymentForm.egrpou = inn
          }

          if (state.isManagerPage) {
            if (phoneNumberForPayment) {
              orderInfo.phone_number_for_payment = '380' + phoneNumberForPayment.value
            }
          }
        }

        if (getters.isCheckoutFormValid) {
          commit('SET_LOADING_COMPONENTS', { totalPrice: true })

          return new Promise((resolve, reject) => {
            let currentEndpoint = '/shop/checkout/create-order/'
            if (state.isGuest) {
              currentEndpoint = '/shop/checkout/create-order-as-guest/'
              orderInfo.recaptcha = state.guestRecaptcha
            }
            axios.post(rootGetters.urlLanguagePrefix + currentEndpoint, qs.stringify({ order: orderInfo }), {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'Accept': 'application/json, text/javascript, */*; q=0.01'
              }
            }).then(response => {
              const { order } = response.data
              commit('SET_CREATE_ORDER_INFO', response.data)

              if (response.data?.user_data?.user_id) {
                commit('UPDATE_USER_DATA', response.data.user_data)
                GoogleEnhancedEcommerce.pushUserIdentity({
                  userId: response.data.user_data.user_id,
                  phone: state.formData.phone || state.formData.recipientPhone,
                  email: state.formData.email || state.formData.recipientEmail,
                  logged: rootState.user.auth ? 'yes' : 'no',
                  userType: 'Client',
                  employeeCompany: 'no',
                  event: 'checkout_success'
                })
              }

              if (order && !order.status && order.error_message) {
                // При ошибке обновляем способы доставки
                dispatch('FETCH_DELIVERY_TYPES', state.formData?.deliveryCity?.id)
                commit('SET_ERROR_FROM_SERVER', order.error_message)
              } else if (order && order.status) {
                localStorage.removeItem(formDataKey)
                dispatch('REMOVE_BONUSES_INFO_FROM_LOCAL_STORAGE')
              }
              localStorage.setItem('analyticsDataReferrer', JSON.stringify({}))
              resolve(order)
            })
              .catch(error => reject(error))
          })
        }
      } catch (e) {
        commit('SET_ERROR_FROM_SERVER', rootGetters.translations('server_error'))
      }
    },
    SET_IS_CONTACT_FORM_VALID_ACTION (ctx, bool) {
      ctx.commit('SET_IS_CONTACT_FORM_VALID', bool)
    },
    SET_LOADING_COMPONENT (ctx, data) {
      ctx.commit('SET_LOADING_COMPONENTS', data)
    },
    SET_IS_DISABLED_CALLBACK_STATUS_ACTION ({ commit }, bool) {
      commit('SET_IS_DISABLED_CALLBACK_STATUS', bool)
    },
    SET_IS_MANAGER_LOGGED ({ commit }, isLogged) {
      commit('SET_IS_MANAGER_LOGGED', isLogged)
    },
    SET_MANAGERS_CLIENT_DATA_ACTION ({ commit }, data) {
      commit('SET_MANAGERS_CLIENT_DATA', data)
    },
    SET_MANAGER_STORE_ACTION ({ rootGetters, commit }, store) {
      return new Promise((resolve, reject) => {
        axios.post(rootGetters.urlLanguagePrefix + '/manager-checkout/set-manager-store/', qs.stringify({ store_uid: store.uid }))
          .then(res => {
            commit('SET_MANAGER_STORE_UID', store.uid)
            commit('SET_MANAGER_STORE', store)
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    }
  }
}
